import { useState, useEffect, useContext } from 'react';
import apiUser from '../../apiUser';
import { UserContext } from '../../contexts/userProvider';
import DataTable from '../Table';
import LoadingSpinner from '../Loader/load';

const LABELS_ENTIDADE = {
    cliente: 'Cliente',
    anexo: 'Anexo',
    linha: 'Linha',
    secretaria: 'Secretaria',
    secretaria_mongo: 'Secretaria (legado)',
    nota_fiscal: 'Nota Fiscal',
    grupo: 'Grupo',
    marca: 'Marca',
    modelo: 'Modelo',
    servico: 'Serviço',
    itens: 'Itens',
};

const formatarDataHora = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} ${hh}:${mm}`;
};

const Auditoria = () => {
    const { setAlert } = useContext(UserContext);
    const [exclusoes, setExclusoes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [detalhe, setDetalhe] = useState(null);

    const carregar = async () => {
        setLoading(true);
        try {
            const response = await apiUser.get('/auditoria/exclusoes', { params: { limite: 200 } });
            const { success, dados, message } = response.data;
            if (success) {
                setExclusoes(dados || []);
            } else {
                setAlert({ visible: true, title: 'Atenção!', placeholder: message || 'Erro ao carregar auditoria', confirm: false, type: 'warning' });
            }
        } catch (err) {
            console.log(err);
            setAlert({ visible: true, title: 'Erro!', placeholder: 'Erro ao carregar auditoria de exclusões.', confirm: false, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        carregar();
    }, []);

    const verDetalhe = (id) => {
        const item = exclusoes.find((e) => String(e.id) === String(id));
        if (item) setDetalhe(item);
    };

    const headers = [
        { label: 'Quando', key: 'quando_fmt', sortable: true },
        { label: 'Usuário', key: 'usuario_label', sortable: true },
        { label: 'Entidade', key: 'entidade_label', sortable: true },
        { label: 'ID alvo', key: 'entidade_id', sortable: false },
        { label: 'Ações', key: 'actions', sortable: false, actions: { visualizar: verDetalhe } },
    ];

    const data = exclusoes.map((e) => ({
        ...e,
        quando_fmt: formatarDataHora(e.created_at),
        usuario_label: e.user_name ? `${e.user_name} (#${e.user_id})` : `#${e.user_id}`,
        entidade_label: LABELS_ENTIDADE[e.entidade] || e.entidade,
    }));

    const parseDados = (raw) => {
        if (raw == null) return null;
        if (typeof raw === 'object') return raw;
        try { return JSON.parse(raw); } catch { return raw; }
    };

    return (
        <div className='w-full min-h-full'>
            <div className='flex items-center justify-between mb-4'>
                <h1 className='text-2xl font-semibold text-gray-900 dark:text-white'>Auditoria de Exclusões</h1>
                <button
                    onClick={carregar}
                    className='px-4 py-2 bg-vox-blue-600 hover:bg-vox-blue-700 text-white rounded-lg transition-colors duration-200'
                >
                    Atualizar
                </button>
            </div>
            {loading ? (
                <LoadingSpinner />
            ) : exclusoes.length === 0 ? (
                <div className='p-6 text-center text-gray-500 dark:text-gray-400'>
                    Nenhuma exclusão registrada.
                </div>
            ) : (
                <DataTable headers={headers} data={data} perPageItems={20} />
            )}

            {detalhe && (
                <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
                    <div className='fixed inset-0 bg-black bg-opacity-50' onClick={() => setDetalhe(null)} />
                    <div className='relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-3xl max-h-[80vh] flex flex-col'>
                        <div className='px-6 py-4 border-b border-gray-200 dark:border-gray-700'>
                            <h2 className='text-xl font-bold text-gray-900 dark:text-white'>
                                Snapshot da exclusão #{detalhe.id}
                            </h2>
                            <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>
                                {LABELS_ENTIDADE[detalhe.entidade] || detalhe.entidade}
                                {detalhe.entidade_id ? ` — id ${detalhe.entidade_id}` : ''}
                                {' • '}{formatarDataHora(detalhe.created_at)}
                                {' • '}{detalhe.user_name || `usuário #${detalhe.user_id}`}
                            </p>
                        </div>
                        <div className='flex-1 min-h-0 overflow-auto p-4'>
                            <pre className='text-xs bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-100 p-4 rounded-lg whitespace-pre-wrap break-words'>
                                {JSON.stringify(parseDados(detalhe.dados), null, 2)}
                            </pre>
                        </div>
                        <div className='px-6 py-3 border-t border-gray-200 dark:border-gray-700 flex justify-end'>
                            <button
                                onClick={() => setDetalhe(null)}
                                className='px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500'
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Auditoria;
